import { css, SerializedStyles, Theme } from "@emotion/react";

export const StyledFallbackErrorScreenContainer = (isMd: boolean): SerializedStyles => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  margin: 2rem 0;

  img {
    height: ${isMd ? "13rem" : "9.5rem"};
  }
`;

export const StyledFallbackErrorScreenText = ({ colors }: Theme): SerializedStyles => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  p:last-child {
    color: ${colors.secondary.darker};
  }
`;
